import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormAutocompleteField2 from 'components/ui/form/FormAutocompleteField2';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormDateField from 'components/ui/form/FormDateField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';
import moment from 'moment';

const validationSchema = yup.object({
  sum: yup.number().required('Pul miqdorini kiritish majburiy!'),
  val: yup.number().required('Valyuta kiritish majburiy!'),
  date: yup.date().required('Sana'),
});

const InboxModal = (props) => {
  const { open, setOpen, setRefetch, itemId } = props;
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      sum: '',
      date: moment().format('YYYY-MM-DD'),
      val: '',
      comment: '',
      partner_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'simple' },
        values,
        `admin/accounts/income/${itemId}`,
        values.name,
        itemId,
        true,
        handleFinishRequest
      );
    },
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        <span>Pulni qabul qilish</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormDateField
                delay={0}
                label={'Sanasi'}
                fieldName='date'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormAutocompleteField2
                delay={0.2}
                label={'Kategoriya'}
                fieldName='category_id'
                formik={formik}
                autocomplete='off'
                path={'/dictionary/expense-category'}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'Valyuta'}
                fieldName='val'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'Summasi'}
                fieldName='sum'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormAutocompleteField2
                delay={0.2}
                label={'Hamkor'}
                fieldName='partner_id'
                formik={formik}
                autocomplete='off'
                path={'/dictionary/partners'}
              />
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.3}
                label={'Izoh'}
                fieldName='comment'
                rows={4}
                multiline
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.4}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default InboxModal;
